module.exports = __webpack_public_path__ + "img/icon-location.3458eba9.svg";